import { jsx, jsxs } from "react/jsx-runtime";
function NoFound() {
    return /*#__PURE__*/ jsxs("svg", {
        width: "440",
        height: "360",
        viewBox: "0 0 440 360",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ jsx("circle", {
                cx: "207.201",
                cy: "155.904",
                r: "136.977",
                fill: "#F1F5F7"
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter0_i_1453_1569)",
                children: /*#__PURE__*/ jsx("path", {
                    d: "M339.192 311.026C314.072 340.198 276.869 358.669 235.352 358.669C218.563 358.669 202.48 355.648 187.615 350.121C200.388 313.374 235.325 286.998 276.423 286.998C300.548 286.998 322.55 296.086 339.192 311.026Z",
                    fill: "#E4E9F1"
                })
            }),
            /*#__PURE__*/ jsx("circle", {
                opacity: "0.4",
                cx: "263.186",
                cy: "336.506",
                r: "14.2383",
                fill: "url(#paint0_linear_1453_1569)"
            }),
            /*#__PURE__*/ jsx("circle", {
                opacity: "0.4",
                cx: "317.539",
                cy: "308.042",
                r: "14.1982",
                fill: "url(#paint1_linear_1453_1569)"
            }),
            /*#__PURE__*/ jsx("path", {
                opacity: "0.4",
                d: "M199.267 327.398C204.73 319.558 211.357 312.591 218.898 306.745C221.27 309.294 222.722 312.711 222.722 316.468C222.722 324.351 216.331 330.742 208.448 330.742C204.952 330.742 201.749 329.485 199.267 327.398Z",
                fill: "url(#paint2_linear_1453_1569)"
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter1_ii_1453_1569)",
                children: /*#__PURE__*/ jsx("circle", {
                    cx: "176.506",
                    cy: "119.764",
                    r: "59.401",
                    fill: "#B0C1D7"
                })
            }),
            /*#__PURE__*/ jsx("path", {
                opacity: "0.2",
                d: "M146.003 68.7835C156.801 68.3128 166.943 65.315 175.853 60.3668C176.071 60.3645 176.289 60.3633 176.507 60.3633C183.816 60.3633 190.817 61.6834 197.284 64.0982C182.716 76.6589 163.745 84.2537 143.001 84.2537C138.471 84.2537 134.027 83.8916 129.694 83.1948C134.189 77.449 139.718 72.5517 146.003 68.7835Z",
                fill: "#F0FCFF"
            }),
            /*#__PURE__*/ jsx("path", {
                opacity: "0.2",
                d: "M207.353 68.9902C191.008 84.0722 169.166 93.2857 145.172 93.2857C138.08 93.2857 131.176 92.4807 124.546 90.9572C121.7 96.0802 119.589 101.668 118.357 107.579C126.937 109.742 135.92 110.891 145.172 110.891C174.596 110.891 201.305 99.267 220.958 80.3602C217.025 75.9276 212.44 72.0874 207.353 68.9902Z",
                fill: "#F9FEFF"
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter2_i_1453_1569)",
                children: /*#__PURE__*/ jsx("path", {
                    d: "M319.976 119.22C312.202 139.979 279.585 168.683 205.333 196.637C126.715 216.728 83.0287 208.719 65.7697 190.064C69.4156 161.2 92.6469 124.132 173.012 96.179C257.746 74.3404 314.156 96.179 319.976 119.22Z",
                    fill: "#E3EAF5"
                })
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter3_i_1453_1569)",
                children: /*#__PURE__*/ jsx("path", {
                    d: "M319.06 115.706C325.08 135.981 275.823 176.158 206.314 196.798C136.805 217.438 72.3211 211.967 66.3007 191.692C60.2804 171.418 103.909 134.338 179.651 111.846C257.423 88.7525 313.039 95.4316 319.06 115.706Z",
                    fill: "#C4D4E7"
                })
            }),
            /*#__PURE__*/ jsx("g", {
                filter: "url(#filter4_i_1453_1569)",
                children: /*#__PURE__*/ jsx("ellipse", {
                    cx: "198.397",
                    cy: "158.187",
                    rx: "68.4401",
                    ry: "17.9361",
                    transform: "rotate(-16.5383 198.397 158.187)",
                    fill: "#8CA2BD"
                })
            }),
            /*#__PURE__*/ jsx("path", {
                opacity: "0.4",
                d: "M326.282 359H182.249L179.532 339.969L151.392 158.119C151.392 158.119 167.567 148.1 196.544 140.183C221.905 133.254 231.499 133.364 231.499 133.364L368.238 339.969L326.282 359Z",
                fill: "url(#paint3_linear_1453_1569)"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M248.719 115.713C248.473 118.282 250.961 120.621 254.275 120.938C257.589 121.255 260.475 119.429 260.72 116.86C260.966 114.29 258.478 111.951 255.164 111.634C251.85 111.318 248.964 113.144 248.719 115.713Z",
                fill: "#E7EFFA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M104.83 168.579C106.427 170.588 109.822 170.547 112.413 168.487C115.005 166.427 115.811 163.129 114.215 161.12C112.618 159.111 109.223 159.152 106.631 161.212C104.04 163.271 103.233 166.57 104.83 168.579Z",
                fill: "#E7EFFA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M158.833 141.543C155.939 143.156 152.579 142.645 151.329 140.401C150.079 138.158 151.411 135.031 154.305 133.419C157.2 131.806 160.559 132.317 161.809 134.561C163.06 136.804 161.727 139.931 158.833 141.543Z",
                fill: "#E7EFFA"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M198.111 124.461C198.59 126.983 201.615 128.527 204.869 127.91C208.122 127.292 210.372 124.747 209.894 122.225C209.415 119.703 206.39 118.159 203.136 118.776C199.882 119.393 197.633 121.938 198.111 124.461Z",
                fill: "#E7EFFA"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M278.325 191.441L280.12 197.448L276.415 198.555L279.107 207.566L271.893 209.721L269.201 200.711L255.165 204.905L253.501 200.357L259.568 168.884L266.895 166.695L274.62 192.548L278.325 191.441ZM260.304 196.826L267.406 194.704L262.874 179.537L262.778 180.034L260.304 196.826Z",
                fill: "#2166FF"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M186.459 236.6L185.812 242.836L181.965 242.436L180.994 251.79L173.505 251.013L174.476 241.659L159.906 240.146L160.114 235.307L177.794 208.572L185.399 209.362L182.613 236.2L186.459 236.6ZM176.479 220.1L176.758 219.678L175.124 235.423L167.751 234.657L176.479 220.1Z",
                fill: "#2166FF"
            }),
            /*#__PURE__*/ jsx("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M237.566 251.373L238.962 244.302C239.469 241.735 239.733 239.438 239.755 237.411C239.78 235.366 239.577 233.574 239.144 232.035C238.715 230.477 238.099 229.161 237.295 228.087C236.515 226.997 235.553 226.12 234.41 225.457C233.267 224.793 231.996 224.323 230.597 224.047C228.834 223.699 227.159 223.717 225.57 224.1C223.985 224.464 222.524 225.261 221.186 226.49C219.849 227.719 218.66 229.405 217.62 231.549C216.598 233.697 215.77 236.38 215.135 239.599L213.739 246.67C213.232 249.238 212.966 251.544 212.941 253.59C212.938 255.62 213.142 257.412 213.552 258.966C213.981 260.524 214.593 261.859 215.389 262.972C216.208 264.069 217.187 264.959 218.326 265.642C219.469 266.306 220.74 266.775 222.139 267.051C223.902 267.399 225.577 267.382 227.166 266.999C228.758 266.596 230.214 265.779 231.532 264.546C232.874 263.297 234.057 261.59 235.082 259.423C236.107 257.256 236.935 254.573 237.566 251.373ZM231.825 241.729L230.004 250.955C229.615 252.929 229.176 254.595 228.69 255.952C228.226 257.294 227.719 258.348 227.169 259.116C226.62 259.883 226.018 260.411 225.363 260.7C224.732 260.974 224.062 261.041 223.353 260.901C222.778 260.787 222.276 260.559 221.846 260.215C221.416 259.871 221.07 259.405 220.808 258.816C220.55 258.207 220.37 257.455 220.268 256.559C220.185 255.667 220.185 254.611 220.266 253.393C220.37 252.159 220.579 250.747 220.893 249.157L222.714 239.931C223.1 237.976 223.532 236.34 224.012 235.021C224.491 233.702 225.013 232.67 225.578 231.926C226.147 231.162 226.745 230.653 227.373 230.399C228.004 230.125 228.674 230.058 229.383 230.198C229.939 230.308 230.432 230.534 230.861 230.878C231.295 231.203 231.643 231.659 231.905 232.249C232.186 232.842 232.37 233.575 232.456 234.448C232.547 235.302 232.541 236.336 232.441 237.551C232.341 238.765 232.135 240.158 231.825 241.729Z",
                fill: "#2166FF"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M75.1391 269.161C75.6045 268.096 77.1158 268.096 77.5813 269.161L79.8111 274.265C80.3487 275.495 81.3309 276.478 82.5615 277.015L87.6651 279.245C88.7306 279.711 88.7306 281.222 87.6651 281.687L82.5615 283.917C81.3309 284.455 80.3487 285.437 79.8111 286.667L77.5813 291.771C77.1158 292.837 75.6045 292.837 75.1391 291.771L72.9093 286.667C72.3717 285.437 71.3894 284.455 70.1589 283.917L65.0552 281.687C63.9898 281.222 63.9898 279.711 65.0552 279.245L70.1589 277.015C71.3894 276.478 72.3717 275.495 72.9093 274.265L75.1391 269.161Z",
                fill: "#D0D7E2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M379.036 94.9607C379.331 94.2855 380.289 94.2855 380.584 94.9607L381.997 98.1951C382.337 98.975 382.96 99.5975 383.74 99.9382L386.974 101.351C387.649 101.646 387.649 102.604 386.974 102.899L383.74 104.312C382.96 104.653 382.337 105.275 381.997 106.055L380.584 109.29C380.289 109.965 379.331 109.965 379.036 109.29L377.623 106.055C377.282 105.275 376.66 104.653 375.88 104.312L372.645 102.899C371.97 102.604 371.97 101.646 372.645 101.351L375.88 99.9382C376.66 99.5975 377.282 98.975 377.623 98.1951L379.036 94.9607Z",
                fill: "#D0D7E2"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M382.388 231.781C382.84 231.174 383.797 231.396 383.936 232.14L384.598 235.701C384.758 236.56 385.236 237.327 385.937 237.848L388.843 240.011C389.45 240.463 389.228 241.42 388.484 241.559L384.923 242.222C384.064 242.381 383.297 242.86 382.776 243.56L380.613 246.466C380.161 247.073 379.204 246.851 379.065 246.108L378.402 242.546C378.243 241.687 377.765 240.92 377.064 240.399L374.158 238.236C373.551 237.785 373.773 236.827 374.517 236.689L378.078 236.026C378.937 235.866 379.704 235.388 380.225 234.687L382.388 231.781Z",
                fill: "#D0D7E2"
            }),
            /*#__PURE__*/ jsxs("defs", {
                children: [
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter0_i_1453_1569",
                        x: "187.615",
                        y: "282.596",
                        width: "164.781",
                        height: "76.0723",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "15.4049",
                                dy: "-4.4014"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "6.6021"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.264271 0 0 0 0 0.383808 0 0 0 0 0.5375 0 0 0 0.13 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1453_1569"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter1_ii_1453_1569",
                        x: "106.101",
                        y: "60.3633",
                        width: "129.806",
                        height: "127.605",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-15.4049",
                                dy: "8.8028"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "5.50175"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1453_1569"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-13.2042",
                                dy: "8.8028"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "4.4014"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.29 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "effect1_innerShadow_1453_1569",
                                result: "effect2_innerShadow_1453_1569"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter2_i_1453_1569",
                        x: "59.1677",
                        y: "87.1631",
                        width: "260.808",
                        height: "125.619",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "-24.2077",
                                dy: "4.4014"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "3.30105"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.72 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1453_1569"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter3_i_1453_1569",
                        x: "65.7493",
                        y: "86.2766",
                        width: "269.808",
                        height: "123.565",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "20",
                                dy: "-11"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "8"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.631373 0 0 0 0 0.698039 0 0 0 0 0.737255 0 0 0 0.4 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1453_1569"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("filter", {
                        id: "filter4_i_1453_1569",
                        x: "132.587",
                        y: "132.203",
                        width: "144.825",
                        height: "60.772",
                        filterUnits: "userSpaceOnUse",
                        colorInterpolationFilters: "sRGB",
                        children: [
                            /*#__PURE__*/ jsx("feFlood", {
                                floodOpacity: "0",
                                result: "BackgroundImageFix"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in: "SourceGraphic",
                                in2: "BackgroundImageFix",
                                result: "shape"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                in: "SourceAlpha",
                                type: "matrix",
                                values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                                result: "hardAlpha"
                            }),
                            /*#__PURE__*/ jsx("feOffset", {
                                dx: "13.2042",
                                dy: "8.8028"
                            }),
                            /*#__PURE__*/ jsx("feGaussianBlur", {
                                stdDeviation: "7.70246"
                            }),
                            /*#__PURE__*/ jsx("feComposite", {
                                in2: "hardAlpha",
                                operator: "arithmetic",
                                k2: "-1",
                                k3: "1"
                            }),
                            /*#__PURE__*/ jsx("feColorMatrix", {
                                type: "matrix",
                                values: "0 0 0 0 0.232812 0 0 0 0 0.30675 0 0 0 0 0.375 0 0 0 0.21 0"
                            }),
                            /*#__PURE__*/ jsx("feBlend", {
                                mode: "normal",
                                in2: "shape",
                                result: "effect1_innerShadow_1453_1569"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint0_linear_1453_1569",
                        x1: "272.221",
                        y1: "327.009",
                        x2: "252.015",
                        y2: "348.544",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#D1DBE8"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#AFBFD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint1_linear_1453_1569",
                        x1: "326.549",
                        y1: "298.572",
                        x2: "306.401",
                        y2: "320.047",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#DFE7F4",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#AFBFD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint2_linear_1453_1569",
                        x1: "217.506",
                        y1: "306.948",
                        x2: "197.25",
                        y2: "328.536",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#DFE7F4",
                                stopOpacity: "0"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#AFBFD3"
                            })
                        ]
                    }),
                    /*#__PURE__*/ jsxs("linearGradient", {
                        id: "paint3_linear_1453_1569",
                        x1: "185.615",
                        y1: "141.705",
                        x2: "216.041",
                        y2: "250.937",
                        gradientUnits: "userSpaceOnUse",
                        children: [
                            /*#__PURE__*/ jsx("stop", {
                                stopColor: "#165DFF",
                                stopOpacity: "0.74"
                            }),
                            /*#__PURE__*/ jsx("stop", {
                                offset: "1",
                                stopColor: "#BAC9FF",
                                stopOpacity: "0"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export { NoFound as default };
